import React from 'react';
import { Select } from '@applyboard/crystal-ui';
import { queryParameterContext } from './../../context';
import { ClockOutlineIcon, SortAscendingOutlineIcon, SortDescendingOutlineIcon } from '@applyboard/ui-icons';

const sortFields = [
  { label: 'Sort by programs (A-Z)', value: 'name', icon: SortAscendingOutlineIcon, direction: 'asc' },
  { label: 'Sort by programs (Z-A)', value: '-name', icon: SortDescendingOutlineIcon, direction: 'desc' },

  { label: 'Field of Study (A-Z)', value: 'fieldOfStudy.name', icon: SortAscendingOutlineIcon, direction: 'asc' },
  { label: 'Field of Study (Z-A)', value: '-fieldOfStudy.name', icon: SortDescendingOutlineIcon, direction: 'desc' },

  { label: 'Program Level (A-Z)', value: 'programLevel.name', icon: SortAscendingOutlineIcon, direction: 'asc' },
  { label: 'Program Level (Z-A)', value: '-programLevel.name', icon: SortDescendingOutlineIcon, direction: 'desc' },

  { label: 'Sort by created (Most recent)', value: '-createdAt', icon: ClockOutlineIcon, direction: 'desc' },
];

export const Sort = () => {
  const { value, setValue } = queryParameterContext.useFilterField('sort', 'PrimaryFilter');

  // TODO: only a subset of icons are allowed as IconOnClose/IconOnOpen. Refer to storybook for the allowed values.
  // const field = sortFields.find((field) => field.value === value);
  // const buttonIcon = field?.direction === 'asc' ? <SortAscendingOutlineIcon /> : <SortDescendingOutlineIcon />;

  return (
    <Select
      value={value || 'code'}
      aria-label="Sort"
      placeholder="Sort"
      onChange={(value) => setValue(value)}
      emphasis="highlighted"
      intent="primary"
      placeholderVariant="indicator"
      appearance="styled"
      // iconOnOpen={buttonIcon}
      // iconOnClose={buttonIcon}
    >
      {sortFields.map((field) => (
        <Select.Option key={field.value} label={field.label} value={field.value} icon={field.icon} />
      ))}
    </Select>
  );
};
